export enum MonitoringType {
  Offline = 'Offline',
  Online = 'Online',
  BatteryCritical = 'BatteryCritical',
  BatteryLow = 'BatteryLow',
  BatteryCombined = 'BatteryCombined',
  OutDated = 'OutDated',
  GatewayOffline = 'GatewayOffline',
  GatewayOnline = 'GatewayOnline',
  All = 'All',
  NotMonitored = 'NotMonitored',
  GatewayNotMonitored = 'GatewayNotMonitored',
  PassiveGatewayOffline = 'PassiveGatewayOffline',
  GatewayServiceOffline = 'GatewayServiceOffline',
  SystemOffline = 'SystemOffline',
  SystemOnline = 'SystemOnline',
  SystemWarning = 'SystemWarning',
  SystemMalfunction = 'SystemMalfunction',
  DeviceMalfunction = 'DeviceMalfunction',
  ConnectorOffline = 'ConnectorOffline',
  ConnectorOnline = 'ConnectorOnline',
}
